import React, { useState } from 'react';
import { 
  Character, CharacterRoll, Modifier, Proficiency,
} from "@dndModels";

import DataUtil from "@utilities/common_utilities";

import CharacterFeatureFromSource from "@dndComponents/character/features/CharacterFeatureFromSource";
import FlexBox from '@components/layout/FlexBox';
import { AbilityScoreType } from '@dndModels/Types';
import CharacterSavingThrowCustomizations from '../customizations/CharacterSavingThrowCustomizations';

const common_util = DataUtil.getInstance();

interface Props { 
  char: Character;
}

export default function CharacterSavingThrowInput({ 
  char,
}: Props) {

  const renderFeatures = () => {
    const saving_throw_profs = char.mind.proficiency_features.filter(cf => 
      cf.floating_feature instanceof Proficiency &&
      cf.floating_feature.proficiency_types.includes("Saving Throw"));
    const saving_throw_modifiers = char.mind.modifier_features.filter(cf => 
      cf.floating_feature instanceof Modifier && 
      ["Saving Throw"].includes(cf.floating_feature.modifies));
    const saving_throw_features = [...saving_throw_profs,...saving_throw_modifiers];
    return (
      <>
        <FlexBox className="header centered">
          Saving Throw Features
        </FlexBox>
        { saving_throw_features.sort((a,b) => { return a.name.localeCompare(b.name) }).map((char_feature, key) => {
          const source = char.char_feature_sources.find(o => 
            o.true_id === char_feature.source_true_id);
          if (source) {
            return (
              <FlexBox key={key}>
                <CharacterFeatureFromSource
                  char={char}
                  obj={char_feature}
                  source={source}
                />
              </FlexBox>
            );
          }
          return null;
        })}
      </>
    );
  }

  return (
    <FlexBox direction="column">
      <FlexBox className="header centered">
        Saving Throws
      </FlexBox>
      <FlexBox>
        <CharacterSavingThrowCustomizations char={char} />
      </FlexBox>
      { renderFeatures() }
    </FlexBox>
  );
}
